import SocialFeed from "../pages/SocialFeed/SocialFeed";
import AppShell from "../components/app/AppShell";
import PreLogin from "../components/PreLogin/PreLogin";
import Footer from "../components/UI/Footer/Footer";
import ProjectsFeedPage from "../pages/ProjectsFeedPage/ProjectsFeedPage";
import CreatorPostedBriefsPage from "../pages/CreatorPostedBriefsPage/CreatorPostedBriefsPage";
// import ProfileCreation from "../pages/ProfileCreation/ProfileCreation";
import SingleProjectPage from "../pages/SingleProjectPage/SingleProjectPage";
import ProjectsLayout from "../layouts/ProjectLayout";
import NotificationsPage from "../pages/NotificationsPage/NotificationsPage";
import MyApplicationsPage from "../pages/MyApplicationsPage/MyApplicationsPage";
import MyApplicationsLayout from "../layouts/MyApplicationsLayout";
import SingleApplicationPage from "../pages/SingleApplicationPage/SingleApplicationPage";
// import CreateProjectPage from "../pages/CreateProjectPage/CreateProjectPage";
import ApplicantsPage from "../pages/ApplicantsPage/ApplicantsPage";
import ApplicantDetails from "../pages/ApplicantDetails/ApplicantDetails";
import UserProfileLayout from "../layouts/UserProfileLayout";
import UserProfilePage from "../pages/UserProfilePage/UserProfilePage";
// import EditProjectPage from "../pages/EditProjectPage/EditProjectPage";
import Landing from "pages/Landing/Landing";
// import SinglePostPage from "pages/SinglePostPage/SinglePostPage";
import PaymentPlanPage from "../pages/PaymentPlanPage/PaymentPlanPage";
import PaymentPage from "pages/PaymentPage/PaymentPage";
import ProtectedRoute from "./HOC/ProtectedRoute";
import AboutUs from "components/AboutUs/AboutUs";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import LandingNavbar from "pages/Landing/Components/Navbar/Navbar";
import ErrorBoundary from "components/errorboundary/Errorboundary";
const LazySignUp = lazy(() => import("../components/Auth/SignUp/SignUp"));
const LazySignIn = lazy(() => import("../components/Auth/SignIn/SignIn"));
const LazyContactUs = lazy(() => import("../pages/ContactUs/ContactUs"));
const LazyForgotPassword = lazy(() =>
  import("../components/Auth/ForgotPassword/ForgotPassword")
);
const LazyResetPassword = lazy(() =>
  import("../components/Auth/ResetPassword/ResetPassword")
);
const LazyProfileCreation = lazy(() =>
  import("../pages/ProfileCreation/ProfileCreation")
);
const LazyEditProject = lazy(() =>
  import("../pages/EditProjectPage/EditProjectPage")
);
const LazySinglePost = lazy(() =>
  import("pages/SinglePostPage/SinglePostPage")
);
const LazyApplicantsPage = lazy(() =>
  import("../pages/ApplicantsPage/ApplicantsPage")
);
const LazyApplicantDetails = lazy(() =>
  import("../pages/ApplicantDetails/ApplicantDetails")
);
const LazyUserProfilePage = lazy(() =>
  import("../pages/UserProfilePage/UserProfilePage")
);
const LazyPaymentPlanPage = lazy(() =>
  import("../pages/PaymentPlanPage/PaymentPlanPage")
);
const LazyPaymentPage = lazy(() =>
  import("pages/PaymentPage/PaymentPage")
);
const LazyNotificationsPage = lazy(() =>
  import("../pages/NotificationsPage/NotificationsPage")
);


const wrapWithErrorBoundary = (element) => {
  return <ErrorBoundary>{element}</ErrorBoundary>;
};

const wrapRoutesWithErrorBoundary = (routes) => {
  return routes.map((route) => {
    const newRoute = {
      ...route,
      element: route.element ? wrapWithErrorBoundary(route.element) : undefined,
    };

    if (route.children) {
      newRoute.children = wrapRoutesWithErrorBoundary(route.children);
    }

    return newRoute;
  });
};

const safeRoutes = [
  {
    path: "/",
    isPrivate: false,
    isRestricted: true,
    element: <Landing />,
  },
  {
    isPrivate: false,
    isRestricted: true,
    path: "/terms-conditions",
    element: <Landing terms={true} />,
  },
  {
    isPrivate: false,
    isRestricted: true,
    path: "/community-guidelines",
    element: <Landing communityGuidelines={true} />,
  },
  {
    path: "/",
    isPrivate: false,
    isRestricted: true,
    element: <PreLogin />,
    children: [
      {
        path: "/signin",
        element: <LazySignIn />,
      },
      {
        path: "/signup",
        element: <LazySignUp />,
      },
      {
        path: "/signup/google",
        element: <LazySignUp />,
      },
      {
        path: "/forgot-password",
        element: <LazyForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <LazyResetPassword />,
      }
    ],
  },
  {
    path: "/contact-us",
    element: (
      <>
        <LandingNavbar />
        <LazyContactUs />
      </>
    ),
  },
  {
    path: "/about-us",
    element: (
      <>
        <LandingNavbar />
        <AboutUs />
      </>
    ),
  },

  {
    path: "profile-creation",
    isPrivate: true,
    element: (
      <>
        {/* <Navbar /> */}
        <LazyProfileCreation />
      </>
    ),
    children: [],
  },
  {
    path: "feed",
    isPrivate: true,
    element: (
      <AppShell>
        <SocialFeed />
      </AppShell>
    ),

    children: [],
  },
  {
    path: "posts/:postId",
    element: (
      <AppShell>
        <LazySinglePost />
      </AppShell>
    ),
    isPrivate: true,
    children: [],
  },

  {
    path: "projects",
    isPrivate: true,
    element: <ProjectsLayout />,
    children: [
      {
        index: true,
        element: <ProjectsFeedPage />,
        isPrivate: false,
      },
      {
        path: "my-briefs",
        element: <CreatorPostedBriefsPage />,
        isPrivate: false,
      },
      {
        path: ":projectId",
        element: <SingleProjectPage />,
        isPrivate: false,
      },
      {
        path: ":projectId/applicants",
        isPrivate: false,
        element: <LazyApplicantsPage />,
      },
      {
        path: ":projectId/applicants/:applicantId",
        isPrivate: false,
        element: <LazyApplicantDetails />,
      },
      {
        path: "create-project",
        element: <Navigate to="/projects?compose=1" replace />,
        isPrivate: false,
      },
      {
        path: "edit-project/:jobId",
        element: <LazyEditProject />,
        isPrivate: false,
      },
    ],
  },
  {
    path: "chat",
    isPrivate: true,
    element: (
      <AppShell>
        <Footer />
      </AppShell>
    ),
    children: [],
  },
  {
    path: "notifications",
    isPrivate: true,
    element: (
      <AppShell>
        <LazyNotificationsPage />
      </AppShell>
    ),
    children: [],
  },
  {
    path: "my-applications",
    isPrivate: true,
    element: <MyApplicationsLayout />,
    children: [
      {
        index: true,
        element: <MyApplicationsPage />,
        isPrivate: false,
      },
      {
        path: ":projectId",
        element: <SingleApplicationPage />,
        isPrivate: true,
      },
    ],
  },
  {
    path: "user-profile",
    element: <UserProfileLayout />,
    isPrivate: true,
    children: [
      {
        index: true,
        element: <LazyUserProfilePage />,
        isPrivate: false,
      },
      {
        path: ":id",
        element: <LazyUserProfilePage />,
        isPrivate: false,
      },
    ],
  },
  {
    path: "payment-plan",
    isPrivate: true,
    element: (
      <ProtectedRoute
        component={
          <AppShell>
            <LazyPaymentPlanPage />
          </AppShell>
        }
      />
    ),
  },
  {
    path: "payment-success",
    isPrivate: true,
    element: (
      <ProtectedRoute
        component={
          <AppShell>
            <LazyPaymentPage />
          </AppShell>
        }
      />
    ),
  },
];

const routes = wrapRoutesWithErrorBoundary(safeRoutes);

export default routes;
